//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TransientObject.js";
import "../no/Dimensions.js";
let d=[[[0,"AlignSymbolWithBaseline",1,0],[0,"DisplayZeroAtBaseline",1,0],[0,"DoglegAngle",1,0],[0,"DoglegCreationOption",1,0],[0,"DoglegDefinition",1,0],[0,"DoglegEndOffset",1,0],[0,"DoglegStartOffset",1,0],[0,"FirstMarginOffset",1,0],[0,"LineArrowDisplayOption",1,0],[0,"MarginSpacing",1,0],[0,"NumberOfMargins",1,0],[0,"OriginDisplay",1,0],[0,"PositiveDirection",1,0],[0,"SymbolAngle",1,0],[0,"SymbolAspectRatio",1,0],[0,"SymbolHeight",1,0],[0,"SymbolLength",1,0],[0,"SymbolScale",1,0],[0,"TextOrientation",1,0],[0,"TextOrientationAngle",1,0],[0,"UserDefinedText",1,0]],[[[],"Dispose",{},0,0]],[]];
SPLM.Annotations.OrdinateDimensionPreferences = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.OrdinateDimensionPreferences";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;